import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'field-type-onefile',
  templateUrl: './field-type-onefile.component.html',
  standalone: true,
  imports: [NgClass,
    TooltipInfoComponent,
    TooltipLawComponent,
    TooltipModule,
    FormsModule,
    AfTranslateDirective,
    AfTranslatePipe
  ]
})
export class FieldTypeOnefileComponent implements OnChanges {
  fieldTypeOnefile:any = {}
  constructor(private commonUtilsService: CommonUtilsService) { }

  @Input()type: any = null;
  @Input()preSelectItem: any = null;
  @Input()fileInfo: any = null;
  @Input()field: any = null;
  @Output() itemSelected = new EventEmitter();
  @ViewChild('fileInput') fileInput: ElementRef;

  ngOnChanges(){
    this.fieldTypeOnefile.fileInfo = this.fileInfo;
    this.fieldTypeOnefile.file = this.preSelectItem? this.preSelectItem: null;
    if(this.field) {
      this.fieldTypeOnefile.titleField = this.field.extendedLabel && this.field.extendedLabel !== ''? this.field.extendedLabel: this.field.label;
      if (this.field.id) {
        this.fieldTypeOnefile.fieldId = this.commonUtilsService.createId();
      }
    }
  }

  removeFile() {
    this.fileInput.nativeElement.value = '';
    this.fileInfo.name = '';
    this.itemSelected.emit({
      newValue: ''
    });
  }

  labelClicked(e:any) {
    if (e.target.tagName !== 'I' && e.target.tagName !== 'INPUT') {
      e.preventDefault();
    }
  }

  fileChanged(e: any) {
    let target = e.target as HTMLInputElement;
    let file:any = target.files as FileList;
    this.fileInfo.name = file[0].name;
    this.itemSelected.emit({
      newValue: file[0]
    });
  }
}
